import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';

@Component({
	selector: 'pcm-user-logout',
	templateUrl: './user-logout.component.html',
	styleUrls: ['./user-logout.component.scss']
})
export class UserLogoutComponent implements OnInit {

	constructor(
		private userService: UserService,
		private router: Router
	) { }

	ngOnInit() {
		console.log('LOGOUT INIT');
		this.checkLogout();
	}

	checkLogout() {
		console.log('CHECK LOGOUT');
		const routerURL = this.router.url;
		if (routerURL.indexOf('logout') > -1) {
			console.log('LOGOUT DETECTED');
			this.userService.removeAuth();
			const self = this;
			const delay = setTimeout(function () {
				// need reload login page to reload NPS script
				// otherwise NPS button wont be generated if the user logout, then login without refreshing
				self.router.navigateByUrl('').then(() => {
					location.reload();
				});
			}, 1000);
		}
	}

}
